export const requiredRule = { required: true, message: '请输入', trigger: ['blur', 'change'] }

export const handleInputMax = (val, max) => {
  if (!val) return val
  const num = parseFloat(val)
  if (!isNaN(num) && num > max) {
    return String(max)
  }
  return val
}

export const handleBlurMin = (val, min) => {
  if (!val) return val
  const num = parseFloat(val)
  if (!isNaN(num) && num < min) {
    return String(min)
  }
  return val
}

export const getRules = (max, min) => {
  const rules = [
    { required: true, message: '请输入', trigger: ['blur', 'change'] },
  ]
  if (max) {
    rules.push({
      validator: (rule, value, callback) => {
        if (value && Number(value) > max) {
          callback(new Error(`最大值不能超过${max}`))
        } else {
          callback()
        }
      },
      trigger: ['blur', 'change'],
    })
  }
  if (min !== undefined) {
    rules.push({
      validator: (rule, value, callback) => {
        if (value && Number(value) < min) {
          callback(new Error(`最小值不能小于${min}`))
        } else {
          callback()
        }
      },
      trigger: ['blur', 'change'],
    })
  }
  return rules
}

export const getDecimalRules = (maxLength, decimalPlaces) => {
  return [
    { required: true, message: '请输入', trigger: ['blur', 'change'] },
    {
      validator: (rule, value, callback) => {
        if (!value) return callback()
        const strValue = String(value)
        if (strValue.length > maxLength) {
          return callback(new Error(`最多输入${maxLength}位`))
        }
        const decimal = strValue.split('.')[1]
        if (decimal && decimal.length > decimalPlaces) {
          return callback(new Error(`最多保留${decimalPlaces}位小数`))
        }
        callback()
      },
      trigger: ['blur', 'change'],
    },
  ]
}

export const getRangeDecimalRules = (max, min, decimalPlaces) => {
  return [
    { required: true, message: '请输入', trigger: ['blur', 'change'] },
    {
      validator: (rule, value, callback) => {
        if (!value) return callback()
        const num = parseFloat(value)
        if (isNaN(num)) {
          return callback(new Error('请输入数字'))
        }
        if (max !== undefined && num > max) {
          return callback(new Error(`最大值不能超过${max}`))
        }
        if (min !== undefined && num < min) {
          return callback(new Error(`最小值不能小于${min}`))
        }
        const strValue = String(value)
        const decimal = strValue.split('.')[1]
        if (decimal && decimal.length > decimalPlaces) {
          return callback(new Error(`最多保留${decimalPlaces}位小数`))
        }
        callback()
      },
      trigger: ['blur', 'change'],
    },
  ]
}
